import styles from "@/styles/Video.module.scss";
import OpenAppButton from "./OpenAppButton";
import AndroidAppDownloadBanner from "./AndroidAppDownloadBanner";
import IOSAppDownloadBanner from "./IOSAppDownloadBanner";

export default function AppKick({ watch }) {
  return (
    <div className={styles.appkick}>
      <p className={styles.message}>
        この動画はコンテンツ保護のため、アプリからのみご視聴いただけます。
      </p>
      <div className={styles.app}>
        <OpenAppButton watch={watch} />
      </div>
      <div className={styles["app-download-banner"]}>
        <IOSAppDownloadBanner />
        <AndroidAppDownloadBanner />
      </div>
    </div>
  );
}
